<div [ngClass]="{ 'border-[#f44336]': required, border: showBorder }" class="flex-[1_1_100%] box-border max-w-full w-full border-[#e5e7eb] rounded-xl overflow-hidden">
  <div [ngClass]="{ 'border-b-[#f44336]': required }" class="w-full h-auto flex flex-row justify-between items-center border-b border-b-[#e5e7eb]">
    <div class="ml-5">
      <mat-checkbox *ngIf="showSelectAll" class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)" i18n>Select all</mat-checkbox>
    </div>

    <div class="flex flex-row justify-end" *ngIf="showExpandCollapse">
      <div class="">
        <button mat-icon-button (click)="expandTree()" matTooltip="Expand">
          <mat-icon title="Expand group">expand_more</mat-icon>
        </button>
      </div>
      <div class="pr-2">
        <button mat-icon-button (click)="collapseTree()" matTooltip="Collapse">
          <mat-icon title="Collapse group">expand_less</mat-icon>
        </button>
      </div>
    </div>
    <div class="mr-6" *ngIf="showExpiryDate" i18n>Expiry Date</div>
  </div>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="group-mat-tree h-full overflow-auto">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <ul [ngClass]="showExpiryDate ? 'w-full' : ''">
        <li class="mat-tree-node" [ngClass]="showExpiryDate ? 'flex w-full justify-between ' : ''">
          <mat-checkbox class="leaf-node" (change)="itemToggle($event.checked, node)" [checked]="node.selected">
            <span [ngClass]="showExpiryDate ? 'max-w-[50ch] block' : ''"> {{ node.name }}</span>
          </mat-checkbox>
          <span class="mr-5" *ngIf="showExpiryDate"> {{ !(node.expiryDate | dateNotExpired) ? 'Expired on ' : '' }} {{ node.expiryDate | spDateFormat: { plainDate: true, isSafe: true } }}</span>
        </li>
      </ul>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [ngClass]="{ disabled: !(node.expiryDate | dateNotExpired) && !(AnyAsset | can: 'expired.download') }">
      <ul class="flex justify-between tree-shadow">
        <li>
          <div class="mat-tree-node" [ngClass]="showExpiryDate ? 'flex w-full justify-between ' : ''">
            <div class="flex items-center">
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              <mat-checkbox [checked]="node.selected" [indeterminate]="node.indeterminate && !node.selected" (change)="itemToggle($event.checked, node)">
                <span [ngClass]="showExpiryDate ? 'block max-w-[50ch]' : ''"> {{ node.name }}</span>
              </mat-checkbox>
            </div>
          </div>
          <ul [class.group-mat-tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
        <div class="mr-5 flex flex-col items-end text-right mt-3" *ngIf="showExpiryDate">
          <div *ngIf="!node.licenseRegions || node.licenseRegions?.length === 0">
            {{ !(node.expiryDate | dateNotExpired) ? 'Expired on ' : '' }} {{ node.expiryDate | spDateFormat: { plainDate: true, isSafe: true } }}
          </div>
          <div *ngFor="let region of node.licenseRegions">
            <span class="text-[#bf360c]" *ngIf="!(region.expiryDate | dateNotExpired); else notExpired"
              ><ng-container i18n>Expired on</ng-container>&nbsp;{{ region.expiryDate | spDateFormat: { plainDate: true, isSafe: true } }}&nbsp;<ng-container *ngIf="region.licenseRegion" i18n
                >for</ng-container
              >&nbsp;{{ region.licenseRegion | optionsLabel: licenseRegionLabels }}</span
            >
            <ng-template #notExpired
              >{{ region.expiryDate | spDateFormat: { plainDate: true, isSafe: true } }}&nbsp;<ng-container *ngIf="region.licenseRegion" i18n>for</ng-container>&nbsp;{{
                region.licenseRegion | optionsLabel: licenseRegionLabels
              }}</ng-template
            >
          </div>
        </div>
      </ul>
    </mat-nested-tree-node>
  </mat-tree>
</div>
